import React, { useEffect, useRef, useState } from "react";
import { Table, Tooltip, Col, Input, Image } from "antd";
import HeadingBack from "../components/common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { render } from "@testing-library/react";
import { CKEditor } from "ckeditor4-react";

const defaultObj = {
  name: "",
  description: "",
  image: ""
};

function City() {
  const { confirm } = Modal;

  const fileInputRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [cityDetails, setCityDetails] = useState({ ...defaultObj });
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { cityList, stateList } = useSelector((state) => ({
    cityList: state?.allApi?.city_list || {},
    stateList: state?.allApi?.state_list?.data || []
  }));
  const listData = cityList?.data ? cityList?.data : [];

  useEffect(() => {
    dispatch(allApiAction.getCities({ page: page, search: search }));
  }, [search, page]);

  const columns = [
    {
      width: "10%",
      key: "image",
      title: "Image",
      dataIndex: "image",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "50px" }}>
              <Image src={URL?.API_BASE_URL + item?.image}
                alt="N/A" />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            style={{ wordBreak: "break-word" }}
          />
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  handleModal({
                    ...item,
                    is_international: item.is_international ? "1" : "0"
                  });
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?.id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async (e) => {
    setShowDelete(false);
    await dispatch(allApiAction.deleteCity({ id: e, page: page }));
    await dispatch(allApiAction.getCities({ page }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const files = event.target.files;
      setSelectedFile(files);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    console.log("value ==> ", value);
    console.log("name ==> ", name);
    setCityDetails((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "type" ? { message: "", url: "" } : {}),
    }));
  };


  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "City",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(e);
      },
      onCancel() {
      },
    });
  };

  const handleModal = (editData) => {
    editData && editData !== undefined ? setCityDetails(editData) : setCityDetails({});
    setIsModalOpen(!isModalOpen);
  };

  const handleSearch = (e) => {
    setSearch(e);
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  const handleSubmit = async () => {
    if (!cityDetails?.name) {
      toast.error("Please enter a name");
      return;
    };
    const data = new FormData();
    data.append("name", cityDetails?.name);
    cityDetails?.description && data.append("description", cityDetails?.description);

    if (selectedFile) {
      for (let i = 0; i < selectedFile?.length; i++) {
        data.append("image", selectedFile[i]);
      }
    };
    try {
      if (cityDetails?.id) {
        data.append("id", cityDetails?.id);
        await dispatch(allApiAction.updateCity(data));
      } else {
        await dispatch(allApiAction.addCity(data));
        setSelectedFile(null);
      };
      dispatch(allApiAction.getCities({ page: 1 }));

      handleModal();
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        setSelectedFile(null);
      };
    } catch (error) {
      console.error("Error during API call:", error)
    };
  };

  return (
    <div>

      {/* Header Bar */}
      <div className="flex" >
        <div>
          <HeadingBack
            title={"City"}
            subHeading={`Total ${cityList?.total || 0} City`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="ml-5 pl-5">
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search..."
            value={search}
          />
        </Col>
        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Form Modal */}
      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title="City Modal"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        {/* Name Input */}
        <Col lg={24} md={24} sm={24} xs={24}>
          <input
            autoComplete="off"
            className="form-control"
            placeholder="Name"
            name="name"
            value={cityDetails?.name}
            onChange={handleTextChange}
          />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <input
            type="file"
            // multiple
            accept="image/*"
            onChange={handleFileChange}
          />
        </Col>

        <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
          <div className="mb-4">
            <label className="form-label">Description</label>
            <div className="quill-container" style={{ marginBottom: '50px' }}>
              <CKEditor
                initData={cityDetails.description}
                config={{
                  extraPlugins: 'table',
                  removePlugins: 'elementspath',
                  resize_enabled: false,
                  toolbarGroups: [
                    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
                    { name: 'insert' },
                    { name: 'styles' },
                    { name: 'colors' },
                    { name: 'links' },
                    { name: 'table' }
                  ],
                  // Optional: Configure table plugin defaults or allowed features
                  table_removeTableTag: false
                }}
                onChange={(event) => {
                  const data = event.editor.getData();
                  setCityDetails((prev) => ({ ...prev, description: data }));
                }}
              />
            </div>
          </div>
        </Col>

      </Modal>


      {/* Pagination Table */}
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(currentPage, pageSize) {
              handlePageChange(currentPage);
            },
            hideOnSinglePage: true,
            total: cityList?.total ? cityList?.total : 0,
          }}
        />
      </div>
    </div>
  );
}

export default City;